import { ArrowRightOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu,TablePaginationConfig, Tag } from "antd";
import { FilterValue, SorterResult } from "antd/es/table/interface";
import { Column, RecordCountBadge, Table } from "components";
import { StyledTableHeader, StyledTableWrapper } from "components/table/table.styled";
import { TableLoader } from "components/table-loader/table-loader";
import dayjs from "dayjs";
import { MatrialFilterFormValuesPaginated } from "features/master/components/master-filter-form";
import { UnLoadingModelApproveReject } from "features/unloading-log/component/model/unloading-approverejectmadel";
import { Dispatch, SetStateAction, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";
import { getRoute } from 'routes/utils';
import { VehicleLog } from "types/vehicle";

// ../model/unloading-approverejectmadel
type LoadingTableProps = {
  isListUpLoading: boolean;
  UploadingList: VehicleLog[];
  itemsCount: number;
  tableParams: MatrialFilterFormValuesPaginated;
  updateParams: Dispatch<SetStateAction<MatrialFilterFormValuesPaginated>>;
  onRefresh :  () => void ;
  isFetching : boolean ;
};

export const UpLoadingLogTable = ({
  UploadingList,
  isListUpLoading,
  itemsCount,
  tableParams,
  updateParams,
  onRefresh ,
  isFetching
}: LoadingTableProps) => {
  const [modelShow, setShowModel] = useState(false)
  const [approveReJect, setApproveReject] = useState("")
  const [logData, setLogData] = useState("")

  // ✅ API call wrapper

  const actionMenu = (record: any) => {
    const items = [];

    if (record.statusId === 2 || record.statusId === 3) {
      // Pending or Rejected → allow Approve
      items.push({
        key: "approve",
        label: "Approve",
        onClick: () => {
          setApproveReject("Approve");
          setShowModel(true);
          setLogData(record);
        },
      });
    }

    if (record.statusId === 2 || record.statusId === 1) {
      // Pending or Approved → allow Reject
      items.push({
        key: "reject",
        label: "Reject",
        onClick: () => {
          setApproveReject("Reject");
          setShowModel(true);
          setLogData(record);
        },
      });
    }

    return items.length > 0 ? <Menu items={items} /> : null;
  };



  // ✅ Table change handler
  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<VehicleLog> | SorterResult<VehicleLog>[]
  ) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by:
        !Array.isArray(sorter) && sorter.order
          ? sorter.order === "ascend"
            ? "name"
            : "-name"
          : undefined,
    });
  };

    const navigate = useNavigate()
      const handleNigate = (item: any) => {      
        
          navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, item.entryId));

      }
  

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge text="UpLoading" count={itemsCount} />
         <Button
          type="link"                // 👈 makes it look like blue text
          onClick={onRefresh}
          loading={isListUpLoading}
          style={{ padding: 0, marginBottom: 16 }}
        >
          Refresh Data
        </Button>
      </StyledTableHeader>

      <Table<VehicleLog>
        dataSource={UploadingList}
        loading={(isListUpLoading || isFetching) && { indicator: <TableLoader /> }}
        rowKey="id"
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: itemsCount,
        }}
      >
        <Column
            key="detail"
            title=""
            dataIndex="detail"
            render={() => (
                <ArrowRightOutlined style={{ cursor: "pointer", fontSize: 16 }} />
            )}
            onCell={(record) => {
                return {
                    style: { cursor: "pointer" }, // ensures cursor shows on hover
                    onClick: () => {
                        const selection = window?.getSelection()?.toString();
                        if (!selection?.length) {
                            handleNigate(record); // ✅ navigate to details
                        }
                    },
                };
            }}
        />
        <Column<VehicleLog> title="Material Name" dataIndex="materialName" />
        <Column<VehicleLog> title="Driver Name" dataIndex="driverName" />
        <Column<VehicleLog> title="Vehicle Number" dataIndex="vNumber" />

        <Column<VehicleLog> title="Entry Weight" dataIndex="entryWeight" />
        <Column<VehicleLog> title="Exit Weight" dataIndex="exitWeight" render={(_, record: any) =>
          record?.exitWeight && record.exitWeight !== 0 ? record.exitWeight : "-"
        } />
        <Column<VehicleLog> title="Net Weight" dataIndex="netWeight" render={(_, record: any) =>
          record?.netWeight && record.netWeight !== 0 ? record.netWeight : "-"
        } />
        <Column<VehicleLog>
          title="Status"
          dataIndex="status"
          render={(_, record: any) => {
            switch (record.statusId) {
              case 1: // Approved
                return <Tag color="green">{record.status}</Tag>;
              case 2: // Pending
                return <Tag color="blue">{record.status}</Tag>;
              case 3: // Rejected
                return <Tag color="red">{record.status}</Tag>;
              case 0: // Not Requested
              default:
                return <Tag color="default">{record.status || "Not Requested"}</Tag>;
            }
          }}
        />

        <Column<VehicleLog>
          title="Unloading Date"
          dataIndex="unloadingDate"
          render={(_, record: any) =>
            record.unloadingDate
              ? dayjs(record.unloadingDate).format("DD-MM-YYYY HH:mm")
              : "-"
          }
        />
        <Column<VehicleLog>
          title="Action"
          key="action"
          render={(_, record) => {
            const menu = actionMenu(record);

            return menu ? (
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button type="text" icon={<MoreOutlined style={{ fontSize: 18 }} />} />
              </Dropdown>
            ) : null; // nothing if statusId = 0
          }}
        />
      </Table>
      {
        modelShow && (<UnLoadingModelApproveReject OpenModel={() => setShowModel(true)} logData={logData} onClose={() => setShowModel(false)} approveReJect={approveReJect} />)
      }
    </StyledTableWrapper>
  );
};
